import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Select, Col, Row, message } from 'antd';
import { AddUser } from '../style';
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { CampaignUpdate } from '../../../Api/Services/CampaignApiServices';
import { getAllMyTemplates, getAllSharedTemplates } from '../../../Api/Services/EmailApiSevices';
import { EmailTemplateIcon } from '../../../components/Icons/Icons';

const { Option } = Select;

const Popup = ({ openTemplate, setOpenTemplate, displayData, configType, getCampaignData }) => {
    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [templates, setTemplates] = useState()
    const [display, setDisplay] = useState(false)
    const handleClose = () => {
        setOpenTemplate(configType);
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    async function getAllTemplate() {
        try {
            const [myTemplates, sharedTemplates] = await Promise.allSettled([
                getAllMyTemplates(),
                getAllSharedTemplates(),
            ]);

            const myData =
                myTemplates.status === "fulfilled" ? myTemplates.value : [];

            const sharedData =
                sharedTemplates.status === "fulfilled" ? sharedTemplates.value : [];

            if (myTemplates.status === "rejected") {
                message.error("Failed to load My Templates");
            }

            if (sharedTemplates.status === "rejected") {
                message.error("Failed to load Shared Templates");
            }

            const allTemplates = [...myData, ...sharedData];

            const filteredResponse = allTemplates.filter(
                (item) => item.entityType === configType
            );

            const options = filteredResponse.map((option) => (
                <Option
                    value={option.templateId}
                    key={option.templateId}
                >
                    {option.templateName}
                </Option>
            ));

            setTemplates(options);

            form.setFieldsValue({
                templateId:
                    configType === "Leads"
                        ? displayData?.leadTemplate
                        : displayData?.contactTemplate,
            });
        } catch (error) {
            // This should rarely execute with Promise.allSettled()
            message.error("Something went wrong.");
        }
    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        setDisplay(true)
        let hideMessage;
        const { templateId } = values;
        const formData = {}
        if (configType === "Leads") { formData.leadTemplate = templateId }
        if (configType === "Contacts") { formData.contactTemplate = templateId }
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await CampaignUpdate(formData, displayData?.campaignId)
            if (response.status === 200) {
                message.success('Template configured')
                hideMessage();
                setDisplay(false)
                getCampaignData()
                handleClose()
                loadingRef.current = false;
                setDelteClick(false)
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDelteClick(false)
            hideMessage();
            setDisplay(false)
            message.error(error)
        }
    }
    useEffect(() => {
        if (configType) {
            getAllTemplate()
        }
    }, [configType])
    return (
        <>
            <Modal
                title="Email Template"
                open={openTemplate}
                width={600}
                onCancel={handleClose}
                maskClosable={false}
                footer={[<div>
                    <Button size="small" htmlType="submit" className="button_colors" loading={deleteClick} disabled={deleteClick || display} onClick={() => form.submit()}>
                        {!deleteClick && <EmailTemplateIcon />}Add
                    </Button>
                </div>
                ]}
            >
                <AddUser>
                    <div className="user-info-form" style={{ padding: "0px 20px" }}>
                        <BasicFormWrapper>
                            <Form style={{ width: '100%' }} form={form} name="Assignto" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                <Row gutter={30} style={{ padding: "0px 20px" }}>
                                    <Col span={24} style={{ margin: "10px 0px" }}>
                                        <Form.Item name="templateId" id="templateId" rules={[{ required: true, message: 'Please select template' }]}>
                                            <Select style={{ width: '100%' }} placeholder="Select email template"
                                                optionFilterProp="children" showSearch
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }>
                                                {templates}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </BasicFormWrapper>
                    </div>
                </AddUser>
            </Modal >
        </>
    );
};

Popup.propTypes = {
    openTemplate: PropTypes.bool.isRequired,
    setOpenTemplate: PropTypes.func.isRequired,
    configType: PropTypes.string.isRequired,
    displayData: PropTypes.object.isRequired,
    getCampaignData: PropTypes.func.isRequired,
};

export default Popup;
